module.exports = __webpack_public_path__ + "static-m/img/zb.3c3bc9db.png";